import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { colors } from 'styles/colors';

const useStyles = makeStyles(() => ({
  container: {
    minHeight: '100vh',
    backgroundColor: colors.topBackground,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  box: {
    borderRadius: 20,
    backgroundColor: colors.white,
    padding: 20,
  },
}));

export default useStyles;
